(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(33933);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ CommonButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50888);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11382);




const CommonButton = (param)=>{
    let { minWidth ="200px" , size ="normal" , type , children , className , loading =false , disabled =false , submit =true , colorLoading ="white" , ...props } = param;
    const antIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        style: {
            fontSize: 24,
            color: colorLoading
        },
        spin: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ...props,
                type: submit ? "submit" : "button",
                disabled: loading || disabled,
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "77d55b610c70874b",
                        [
                            minWidth
                        ]
                    ]
                ]) + " " + (props && props.className != null && props.className || "button ".concat(type, " ").concat(className || "", " ").concat(size)),
                children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    indicator: antIcon
                }) : children
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "77d55b610c70874b",
                dynamic: [
                    minWidth
                ],
                children: ".button.__jsx-style-dynamic-selector{font-weight:400;font-size:16px;line-height:24px;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;height:40px;-webkit-transition:all.3s;-moz-transition:all.3s;-o-transition:all.3s;transition:all.3s}.button.__jsx-style-dynamic-selector:hover{cursor:pointer}.button.__jsx-style-dynamic-selector:not(.min-w-auto){min-width:200px;min-width:".concat(minWidth, "}.b-radius-sm.__jsx-style-dynamic-selector{-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px}.small.__jsx-style-dynamic-selector{height:35px}.button.__jsx-style-dynamic-selector:hover{opacity:.8}.primary.__jsx-style-dynamic-selector{background-color:#00c4c4;color:#fff;border:1px solid#00c4c4;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.primary-dark.__jsx-style-dynamic-selector{background-color:#2f9191;color:#fff;border:1px solid#2f9191;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.secondary.__jsx-style-dynamic-selector{background-color:#ffba00;color:#fff}.danger.__jsx-style-dynamic-selector{background-color:#f00;color:#fff}.indigo.__jsx-style-dynamic-selector{background-color:#4fe8e8;color:#fff;border:1px solid ##90e7e7;-webkit-box-shadow:0px 4px 8px#00000065;-moz-box-shadow:0px 4px 8px#00000065;box-shadow:0px 4px 8px#00000065}.neutral.__jsx-style-dynamic-selector{background-color:#693f00;color:#fff;border:2px solid#693f00}.link.__jsx-style-dynamic-selector{background-color:#fff;color:#00c4c4;border:3px solid#fff;font-weight:bold}.cancel.__jsx-style-dynamic-selector{background-color:#fff;color:#693f00;font-size:14px;font-weight:bold;border:3px solid#fff}button.__jsx-style-dynamic-selector:disabled,button[disabled].__jsx-style-dynamic-selector{border:1px solid#ccc;background-color:#ccc;color:#666;cursor:not-allowed}")
            })
        ]
    });
};


/***/ }),

/***/ 65060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FormButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


const FormButton = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("text-center mt-10 md:mt-[60px]", className),
        children: children
    });
};


/***/ }),

/***/ 34939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ FormInline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);


const FormInline = (param)=>{
    let { label , className , labelClassName , children , id ="" , error  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                id: id,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("form-inline-row md:flex mb-[16px] items-center justify-start", className),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("min-w-[200px] text-base font-bold text-[#5D5D5D]", labelClassName),
                        children: label
                    }),
                    children
                ]
            }),
            !!error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("text-error note mb-5 text-right"),
                children: [
                    error,
                    " "
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FormRow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);


const FormRow = (param)=>{
    let { label , mandatory , mandatoryStyle , mandatoryContent , error , errorStyle , note , className , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-894f77db5803b6b6" + " " + "mb-5 md:mb-[30px] form-row ".concat(className),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-894f77db5803b6b6" + " " + "mb-[10px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-894f77db5803b6b6" + " " + "text-[13px] leading-[20px] md:text-[15px] md:leading-[22px] font-bold",
                                children: label
                            }),
                            mandatory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "jsx-894f77db5803b6b6" + " " + "ml-[10px] ".concat(mandatoryStyle !== null && mandatoryStyle !== void 0 ? mandatoryStyle : "alert"),
                                children: mandatoryContent !== null && mandatoryContent !== void 0 ? mandatoryContent : "＊必須"
                            })
                        ]
                    }),
                    children,
                    !!error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-894f77db5803b6b6" + " " + "text-left mt-[10px] ".concat(errorStyle !== null && errorStyle !== void 0 ? errorStyle : "alert"),
                        children: error
                    }),
                    !!note && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-894f77db5803b6b6" + " " + "text-left mt-[10px] note",
                        children: note
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "894f77db5803b6b6",
                children: ".alert.jsx-894f77db5803b6b6{font-size:12px;color:#ff0909}.note.jsx-894f77db5803b6b6{font-size:12px;color:#333;opacity:50%}"
            })
        ]
    });
};


/***/ }),

/***/ 2738:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const pageListAuthen = {
    login: {
        text: "ログイン",
        url: "/login"
    },
    forgotPassword: {
        text: "パスワード再発行申請",
        url: "/forgot-password"
    },
    resetPassword: {
        text: "パスワード再設定",
        url: "/reset-password"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (pageListAuthen);


/***/ }),

/***/ 61210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ pageList; },
/* harmony export */   "O": function() { return /* binding */ pageDynamicList; }
/* harmony export */ });
/* harmony import */ var _admin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44300);
/* harmony import */ var _authen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2738);
/* harmony import */ var _company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29910);



const pageList = {
    ..._company__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    ..._admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    ..._authen__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
};
const pageDynamicList = {
    userDetail: (id, text)=>({
            text,
            url: "/user/".concat(id)
        }),
    //ADMIN
    //Company
    adminCompanyDetail: (id, text)=>({
            text,
            url: "/admin/master/companies/".concat(id)
        }),
    adminUpdateCompany: (id, text)=>({
            text,
            url: "/admin/master/companies/".concat(id, "/update")
        }),
    //Employee
    adminCreateEmployee: (id, text)=>({
            text,
            url: "/admin/master/employees/create?id=".concat(id)
        }),
    adminEmployeeDetail: (id, text)=>({
            text,
            url: "/admin/master/employees/".concat(id)
        }),
    adminUpdateEmployee: (id, text)=>({
            text,
            url: "/admin/master/employees/".concat(id, "/update")
        }),
    adminEmployeeCreatePosition: (id, text)=>({
            text,
            url: "/admin/master/employees/".concat(id, "/positions")
        }),
    //Officer
    adminOfficerCompanyDetail: (id, text)=>({
            text,
            url: "/admin/master/officer-management/companies/".concat(id)
        }),
    //Meeting
    adminMeetingDetail: (id, text)=>({
            text,
            url: "/admin/meetings/".concat(id)
        }),
    //Template Meeting
    adminTemplateMeetingDetail: (id, text)=>({
            text,
            url: "/admin/template-meetings/".concat(id)
        }),
    adminTemplateMeetingClone: (id, text)=>({
            text,
            url: "/admin/template-meetings/".concat(id, "/clone")
        }),
    //Attendance
    adminAttendanceDetail: (id, text)=>({
            text,
            url: "/admin/attendances/".concat(id)
        }),
    //COMPANY
    //Company Meeting
    companyMeetingDetail: (id, text)=>({
            text,
            url: "/company/meetings/".concat(id)
        })
};


/***/ }),

/***/ 33933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LoginPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/containers/app-layout/index.tsx + 4 modules
var app_layout = __webpack_require__(22645);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 12 modules
var input = __webpack_require__(16333);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/common/components/buttons/index.tsx
var buttons = __webpack_require__(60907);
// EXTERNAL MODULE: ./src/common/components/forms/form-button.tsx
var form_button = __webpack_require__(65060);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./src/common/components/forms/form-container.tsx


const FormContainer = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-ccb2418e5e6f981e" + " " + "form-container ".concat(className),
                children: children
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "ccb2418e5e6f981e",
                children: ".ant-checkbox-inner{-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.ant-radio-inner{width:20px;height:20px;border-width:2px}.form-container .ant-radio-wrapper:hover .ant-radio,.ant-checkbox-inner,.form-container .ant-radio:hover .ant-radio-inner,.form-container .ant-radio-input:focus+.ant-radio-inner,.form-container .ant-radio-checked .ant-radio-inner{border-color:#f19ca6}.form-container .ant-radio-inner::after{background-color:#f19ca6}.ant-radio-input:focus+.ant-radio-inner{-webkit-box-shadow:0 0 0 3px#fdf5ff;-moz-box-shadow:0 0 0 3px#fdf5ff;box-shadow:0 0 0 3px#fdf5ff}.form-container .ant-checkbox-wrapper:hover .ant-checkbox-inner,.form-container .ant-checkbox:hover .ant-checkbox-inner,.form-container .ant-checkbox-input:focus+.ant-checkbox-inner{border-color:#f19ca6}.form-container .ant-checkbox-checked .ant-checkbox-inner{background-color:#f19ca6;border-color:#f19ca6}.form-container .ant-checkbox-checked::after{border-color:#f19ca6}.form-container input.ant-input{padding:10px 20px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.form-container .ant-select{width:100%}.form-container .ant-select-selector{-webkit-border-radius:3px!important;-moz-border-radius:3px!important;border-radius:3px!important;height:44px!important}.form-container .ant-input,.form-container .ant-input-password{border-color:#707070!important}.ant-select-selection-item-remove{display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.form-container .ant-input-affix-wrapper>input.ant-input{padding:6px 9px}@media(max-width:768px){.form-container input.ant-input{padding:10px 15px}.form-container .ant-input-affix-wrapper>input.ant-input{padding:6px 4px}}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/common/components/forms/form-inline.tsx
var form_inline = __webpack_require__(34939);
// EXTERNAL MODULE: ./src/common/components/forms/form-row.tsx
var form_row = __webpack_require__(87624);
// EXTERNAL MODULE: ./src/common/helpers/page/index.ts
var page = __webpack_require__(61210);
// EXTERNAL MODULE: ./src/common/helpers/page/authen.ts
var authen = __webpack_require__(2738);
// EXTERNAL MODULE: ./src/stores/hooks/index.ts
var hooks = __webpack_require__(33654);
;// CONCATENATED MODULE: ./src/containers/login/index.tsx














function LoginContainer() {
    var _errors_email, _errors_password;
    const { control , handleSubmit , formState: { errors  }  } = (0,index_esm/* useForm */.cI)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    const store = (0,hooks/* useAuthStore */.tN)();
    const onSubmit = async (data)=>{
        try {
            setError("");
            setLoading(true);
            await store.login(data);
        } catch (error) {
            setError("「ログインID」または、「パスワード」が違います。");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: page/* pageList.login.text */.H.login.text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "login-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "text-2xl md:text-5xl text-center mt-10 md:mt-0 text-[#5D5D5D]",
                        children: [
                            "横浜商工会議所",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "会議出欠管理システム"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
                        className: "mt-10 md:mt-20 w-fit mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_inline/* FormInline */.K, {
                                    label: "ログインID",
                                    className: "md:!block",
                                    error: (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message,
                                    labelClassName: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "email",
                                        rules: {
                                            required: "「ログインID」を入力してください。",
                                            pattern: {
                                                value: /.{4,}/,
                                                message: "ログインIDは4文字以上で入力してください。"
                                            }
                                        },
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field: { ref: _ , ...others }  } = param;
                                            return (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                ...others,
                                                className: "md:!w-[474px]"
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_inline/* FormInline */.K, {
                                    label: "パスワード",
                                    className: "md:!block",
                                    error: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message,
                                    labelClassName: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                        control: control,
                                        name: "password",
                                        rules: {
                                            required: "「パスワード」を入力してください。",
                                            pattern: {
                                                value: /.{8,}/,
                                                message: "パスワードは8文字以上で入力してください。"
                                            }
                                        },
                                        render: (param)=>/*#__PURE__*/ {
                                            let { field: { ref: _ , ...others }  } = param;
                                            return (0,jsx_runtime.jsx)(input/* default.Password */.Z.Password, {
                                                ...others,
                                                className: "md:!w-[474px]"
                                            });
                                        }
                                    })
                                }),
                                !!error && /*#__PURE__*/ (0,jsx_runtime.jsx)(form_row/* FormRow */.p, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center text-[#FF0909]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: error
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(form_button/* FormButton */.O, {
                                    className: "!mt-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CommonButton */.J, {
                                        type: "primary",
                                        minWidth: "180px",
                                        loading: loading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: "ログイン"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center mt-[30px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: authen/* default.forgotPassword.url */.Z.forgotPassword.url,
                                        className: "underline text-[#00C4C4] text-base font-bold",
                                        children: "パスワードをお忘れの方はこちら"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/login/index.tsx



function LoginPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginContainer, {})
    });
}
LoginPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(app_layout/* default */.Z, {
        minWidth: false,
        noMargin: true,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5639,4217,6333,7536,2645,9774,2888,179], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);